import Route from "@ember/routing/route";
import { NotFoundError } from "glesys-controlpanel/utils/errors";

export default class RemoteHandsDetailsRoute extends Route {
  async model(params) {
    const { project } = this.modelFor("organization");
    const [remoteHandsRequests, colocationRacks] = await Promise.all([
      project.get("remoteHandsRequest"),
      project.get("colocationRacks"),
    ]);
    const remoteHandsRequest = remoteHandsRequests.find(
      (remoteHandsRequest) => remoteHandsRequest.id === params.remote_hands_request_id,
    );

    if (!remoteHandsRequest) {
      throw new NotFoundError();
    }

    return { remoteHandsRequest, colocationRacks };
  }
}
